import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_HallSweepActivation } from "../shared/data.service";
import { QREmailRequest } from "../shared/QREmailRequest";

@Component({
	selector: "app-email-hsactivation",
	templateUrl: "./email-hsactivation.component.html",
	styleUrls: ["./email-hsactivation.component.css"],
})
export class EmailHSActivationComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private HSActivationService: DataService_HallSweepActivation
	) {}

	ngOnInit(): void {
		this.QRCode = this.dialogConfig.data.QRCode;
		// this.QRTextRaw = this.dialogConfig.data.QRTextRaw;
		this.ExpireDateDesc = this.dialogConfig.data.ExpireDateDesc;
		this.ActivationCode = this.dialogConfig.data.ActivationCode;
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	lstEmail: any = "";
	QRCode: any = "";
	// QRTextRaw: any = "";s
	ActivationCode: any = "";
	ExpireDateDesc: any = "";

	Processing: any = false;

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////
	onSend() {
		this.Processing = true;

		let parms: QREmailRequest = {
			lstEmail: this.lstEmail,
			QRCodeBase64: this.QRCode,
			// QRTextRaw: this.QRTextRaw,
			ExpireDate: this.ExpireDateDesc,
			ActivationCode: this.ActivationCode,
		};

		var result = this.HSActivationService.HSActivationEmail(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Email(s) were sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send Email(s)",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////
}
